import { environment } from '@environments/environment';

export const GET_CUSTOM_KITCHENS_QUERY = (langcode: string) => ({
  query: '_search',
  index: environment.integrations?.fournierWebservice?.index_finitions ?? '',
  body: {
    size: 10000,
    query: {
      bool: {
        filter: [
          {
            term: {
              search_api_datasource: 'entity:taxonomy_term',
            },
          },
          {
            term: {
              vid: 'cuisine_sur_mesure',
            },
          },
          {
            term: {
              search_api_language: langcode,
            },
          },
        ],
      },
    },
    _source: ['name', 'field_visuel', 'field_page_link', 'description'],
  },
});
